import { TemplateResult } from "lit-html";

export enum USER_ACCOUNT_SETTINGS_TAB_LIST {
  PROFILE = "Profile",
  SECURITY = "Security",
  APPEARANCE = "Appearance",
  NOTIFICATION = "Notification",
}

export enum USER_ACCOUNT_SETTINGS_MODE {
  MODAL = "MODAL",
  PAGE = "PAGE",
}

export enum USER_ACCOUNT_SETTINGS_SIDEBAR_DISPLAY_TYPE {
  BURGER = "BURGER",
  REGULAR = "REGULAR",
}

export enum USER_ACCOUNT_SETTINGS_ORIENTATION {
  VERTICAL = "VERTICAL",
  HORIZONTAL = "HORIZONTAL",
}

export enum USER_ACCOUNT_SETTINGS_WIDGETS_LAYOUT {
  COLUMN = "COLUMN",
  ROW = "ROW",
}

export interface IProfileContentCustomizations {
  account?: IProfileWidgetCustomization;
  personalInfo?: IProfileWidgetCustomization;
  locations?: IProfileWidgetCustomization;
  urls?: IProfileWidgetCustomization;
}

export interface IProfileWidgetCustomization {
  icon?: HTMLElement | TemplateResult | Element;
  title?: string;
}
